import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  static targets = ["searchInput"];

  connect() {
    super.connect();
  }

  search(event) {
    const query = event.target.value;
    const url = new URL(window.location);
    if (query) {
      url.searchParams.set("query", query);
    } else {
      url.searchParams.delete("query");
    }
    window.history.pushState({}, "", url);
    this.stimulate("Wines#search", { query });
  }
}
